import { addDoc, collection } from 'firebase/firestore';
import { db } from '../config/firebase';

export interface AuthLogEntry {
  event:
    | 'signup'
    | 'login_success'
    | 'login_failure'
    | 'primary_camper_create_failure'
    | 'profile_create_started'
    | 'profile_create_success'
    | 'profile_create_failure'
    | 'registration_wizard_started'
    | 'registration_submitted_success'
    | 'registration_submitted_failure'
    | 'password_reset_requested'
    | 'password_reset_email_dispatched'
    | 'password_reset_email_dispatch_failed'
    | 'account_linking_attempt'
    | 'account_linking_success'
    | 'account_linking_failure';
  email: string;
  timestamp?: Date;
  userId?: string;
  details?: any;
  error?: string;
}

export const logAuthEvent = async (entry: AuthLogEntry) => {
  try {
    await addDoc(collection(db, 'authLogs'), {
      ...entry,
      timestamp: new Date()
    });
  } catch (error) {
    console.error('Failed to write auth log:', error);
  }
}; 